class ClientActivationUsersController {
  static controller($scope, $state, $stateParams, ClientRegistrationService, $translate) {
    'ngInject';
    
    $translate.use($state.params.lang);
    ClientRegistrationService.activateAccount($state.params.email, $state.params.token).then(function(data){
      $state.go('public.users.client.client-activation-confirm' , {userName : $state.params.email});
    });
  };
}

export default ClientActivationUsersController.controller;


// WEBPACK FOOTER //
// ./src/users/client/client-activation.users.controller.js